var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_6007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8276 37.6564H37.5776V14.5317C37.5776 13.8845 37.0529 13.3599 36.4058 13.3599H31.7183C31.0711 13.3599 30.5465 13.8845 30.5465 14.5317V37.6564H28.2027V22.3441C28.2027 21.6969 27.6781 21.1723 27.0309 21.1723H22.3434C21.6963 21.1723 21.1716 21.6969 21.1716 22.3441V37.6564H18.8279V26.6409C18.8279 25.9938 18.3032 25.4691 17.656 25.4691H12.9686C12.3214 25.4691 11.7967 25.9938 11.7967 26.6409V37.6564H9.453V29.4534C9.453 28.8062 8.92832 28.2815 8.28114 28.2815H3.5937C2.94652 28.2815 2.42184 28.8062 2.42184 29.4534V37.6564H1.17186C0.52468 37.6564 0 38.1811 0 38.8283C0 39.4754 0.52468 40.0001 1.17186 40.0001H38.8276C39.4748 40.0001 39.9995 39.4754 39.9995 38.8283C39.9995 38.1811 39.4748 37.6564 38.8276 37.6564Z",
    fill: "#00E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17186 25.1799C8.48566 25.1799 16.417 22.5532 23.5048 17.7837C29.0559 14.0482 33.6833 9.27613 36.5576 4.38971L37.6957 8.63708C37.836 9.16066 38.5135 9.613 39.1309 9.46566C39.7605 9.3155 40.127 8.65559 39.9595 8.03044L38.0406 0.868825C37.873 0.243755 37.2307 -0.127333 36.6054 0.0402425L29.4437 1.9592C28.8186 2.1267 28.4477 2.76927 28.6152 3.39441C28.7827 4.01956 29.425 4.39065 30.0504 4.223L34.664 2.98676C31.9824 7.64654 27.5506 12.2362 22.1963 15.8392C15.4911 20.3513 8.0245 22.8362 1.17186 22.8362C0.52468 22.8362 0 23.3609 0 24.008C0 24.6552 0.52468 25.1799 1.17186 25.1799Z",
    fill: "#00E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_6007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.048903149611575cebe003dbd46adf29.svg";
export { ForwardRef as ReactComponent };